export default "__VITE_ASSET__hF7bpc4XrK79zPSWRvXggw__"